import React from 'react';
import type { PlacesType } from 'react-tooltip';

interface CanvasButtonProps {
  title?: string;
  icon: React.ReactNode;
  tooltipContent?: string;
  tooltipPlace?: PlacesType;
  onClick: () => void;
  disabled?: boolean;
  addStyle?: string;
}

export const CanvasButton = ({
  title,
  icon,
  tooltipContent,
  tooltipPlace,
  onClick,
  disabled,
  addStyle,
}: CanvasButtonProps) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      data-tooltip-content={tooltipContent}
      data-tooltip-id="tooltip"
      data-tooltip-place={tooltipPlace}
      data-tooltip-delay-show={100}
      data-tooltip-offset={0}
      className={`flex h-10 w-10 cursor-pointer items-center justify-center bg-neutralBG transition duration-100 hover:bg-[#ededed] dark:bg-[#333135] dark:hover:bg-[#545454] ${title !== 'nextPrevPage' ? 'rounded-md' : ''} ${addStyle} `}
    >
      {icon}
    </button>
  );
};
